import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// import { ManageYourApplications } from '@pepper-ui/common';
import { Button } from 'govuk-react-jsx';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import useTitle from '../../hooks/useTitle';
import { getConfigurableDeadlines } from '../../firebase';

const InstallerDashboardFirstTime = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [carparkCommercial, setCarparkCommercial] = useState(false);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'SMEReg.DashboardFirstTime.s5',
    'Manage your applications - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  useEffect(() => {
    const fetchWordingTemplates = async () => {
      setIsLoading(true);
      const configurableDeadlines = await getConfigurableDeadlines();
      if (!configurableDeadlines?.data) {
        setIsLoading(false);
        console.log('Configurable deadlines data is undefined');
      }
      const closeToCustomerApplicationCutoffDates =
        configurableDeadlines.data.closeToCustomerApplicationDates;
      if (
        configurableDeadlines.data.success &&
        closeToCustomerApplicationCutoffDates
      ) {
        if (
          closeToCustomerApplicationCutoffDates?.stopToCreateCustomerApplicationCarParkStaffAndFleet
        ) {
          setCarparkCommercial(
            closeToCustomerApplicationCutoffDates?.stopToCreateCustomerApplicationCarParkStaffAndFleet
          );
        }
        setIsLoading(false);
      }
    };
    fetchWordingTemplates();
  }, []);
  const handleBtnClick = () => {
    window.location.assign('/car-parks/sme-app/staff-and-fleet');
  };
  if (isLoading) {
    return (
      <div className="govuk-grid-row">
        <p className="govuk-body">Loading......</p>
      </div>
    );
  }
  const pageModel = (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'SMEReg.DashboardFirstTime.s1',
          'Manage your applications'
        )}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'SMEReg.DashboardFirstTime.s2',
          'You have not started any grant applications yet.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'SMEReg.DashboardFirstTime.s3',
          'Once you submit an application, you will be able to see it and track its progress here.'
        )}
      </p>
      {!carparkCommercial ? (
        <p className="govuk-body govuk-!-margin-top-3 govuk-!-font-weight-bold govuk-!-color-red">
          {copyProvider.getCopy(
            'dashboardHub.DashboardPMC.s30',
            'This grant type is no longer open to new applications.'
          )}
        </p>
      ) : (
        <Button
          className="govuk-button"
          onClick={handleBtnClick}
          disabled={!carparkCommercial}
        >
          {copyProvider.getCopy(
            'SMEReg.DashboardFirstTime.s4',
            'Start a new application'
          )}
        </Button>
      )}
    </>
  );
  return pageModel;
  // return (
  //   <>
  //     <ManageYourApplications
  //       heading={copyProvider.getCopy(
  //         'SMEReg.DashboardFirstTime.s1',
  //         'Manage your applications'
  //       )}
  //       body={{
  //         line1: copyProvider.getCopy(
  //           'SMEReg.DashboardFirstTime.s2',
  //           'You have not started any grant applications yet.'
  //         ),
  //         line2: copyProvider.getCopy(
  //           'SMEReg.DashboardFirstTime.s3',
  //           'Once you submit an application, you will be able to see it and track its progress here.'
  //         ),
  //       }}
  //       button={{
  //         text: copyProvider.getCopy(
  //           'SMEReg.DashboardFirstTime.s4',
  //           'Start a new application'
  //         ),
  //         onClick: carparkCommercial && handleBtnClick,
  //         disabled: true,
  //       }}
  //     />
  //     {!carparkCommercial && (
  //       <p className="govuk-body govuk-!-margin-top-3 govuk-!-font-weight-bold govuk-!-color-red">
  //         {copyProvider.getCopy(
  //           'dashboardHub.DashboardPMC.s30',
  //           'This grant type is no longer open to new applications.'
  //         )}
  //       </p>
  //     )}
  //   </>
  // );
};

export default InstallerDashboardFirstTime;
